export default "__VITE_ASSET__DcOpeQuu__"